/** @format */

export const PDF_VIEWER_OPEN_CLASS = 'pdf-viewer-open';

